import { InputLabel } from '@material-ui/core'
import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
`
export const Label = styled(InputLabel)`
  margin-bottom: 8px;
  min-width: 352px;
`

export const NomeSecao = styled.h1`
  ${({ theme }) => css`
    color: ${theme.colors.black};
    font-weight: ${theme.font.extraBold};
    font-size: ${theme.font.sizes.medium};
  `}
  margin-bottom: 24px;
`
